/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Org_Contract_PrepaidInputs */



/**
* | output |
* | --- |
* | "{amount} prepaid usage" |
*
* @param {Partner_Org_Contract_PrepaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_prepaid = /** @type {((inputs: Partner_Org_Contract_PrepaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_PrepaidInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} vorausbezahlte Nutzung`)
	return /** @type {LocalizedString} */ (`${i?.amount} prepaid usage`)
});